export const currentEstimate = (state) => state.currentEstimate
export const estimates = (state) => state.estimates
export const estimateStatus = (state) => state.estimateStatus
